module.exports = __webpack_public_path__ + "media/images/logos/07-7480d8e113b50c273f970061e5afdf6d.png";